import { mount } from 'svelte';
import App from './App.svelte';
import { initAuth } from '$lib/auth.svelte';
import { initSentry, captureException } from '$lib/sentry';
import './app.css';

// Initialize error tracking
initSentry();

// Catch unhandled promise rejections (Sentry GlobalHandlers covers window.onerror)
window.addEventListener('unhandledrejection', (event) => {
  captureException(event.reason);
});

// Validate stored token before rendering
initAuth().finally(() => {
  mount(App, { target: document.getElementById('app')! });
});
